import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { StorageService } from "../storage/storage.service";
import { FIREBASE_COLLECTIONS } from "src/app/enums/types.enum";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { DocumentReference } from "firebase/firestore";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  private _renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    private storageService: StorageService,
    private firestore: AngularFirestore
  ) {
    this._renderer = this.rendererFactory.createRenderer(null, null);
  }

  private getToken() {
    let data = this.storageService.get("user");
    const headers = {
      Authorization: `Bearer ${data?.token}`, // Replace `token` with your actual bearer token
    };
    return headers;
  }

  getDocWithId = (id: string, document: keyof typeof FIREBASE_COLLECTIONS) => {
    return this.firestore.doc(`${document}/${id}`).valueChanges();
  };

  getDocWithDocumentReference = (documentRef: DocumentReference) => {
    return new Promise((resolve, reject) => {
      this.firestore
        .doc(documentRef.path)
        .valueChanges()
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  };

  toggleScrollFromBody = (value: boolean) => {
    this._renderer.setStyle(
      document.body,
      "overflow-y",
      value ? "auto" : "hidden"
    );
  };
}
